module.exports = __webpack_public_path__ + "img/vip-1.5c5c2030.png";